import {
    LOG_ERROR,
    LOG_LIST_UPDATED,
    GET_LOG_BY_ID,
    LOG_SEARCH_PARAMATERS_UPDATE,
    LOADING_LOG_LIST_DATA,
    LOADING_ON_LOG_SUBMIT,
    RESET,
    LOAD_PAGE,
  } from "actions/types";
  import * as Constants from "constants/index";

  const initialState = {
    logList: {
      page: 1,
      data: [],
      count: 0
    },
    currentLog: null,
    loadingLogList: true,
    loadingLog: true,
    loadingListData: true,
    error: {},
    sortingParams: {
      limit: Constants.DEFAULT_PAGE_SIZE,
      page: 1,
      orderBy: "created_at",
      ascending: "desc",
      query: "",
      filters:[],
    }
  };

  export default function(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case RESET:
        return {
          ...initialState,
          loadingLog: state.loadingLog,
          loadingLogList: state.loadingLogList,
          loadingListData: state.loadingListData,
        }
      case LOAD_PAGE:
        return {
          ...state,
          loadingLog: false
        };
      case LOG_ERROR:
        return {
          ...state,
          error: payload,
          loadingLog: false,
          loadingLogList: false,
          loadingListData: false,
        };
      case GET_LOG_BY_ID:
        return {
          ...state,
          currentLog: payload,
          loadingLog: false,
        };
      case LOG_LIST_UPDATED:
        return {
          ...state,
          logList: {
            data: payload.data,
            page: payload.metadata[0].current_page,
            count: payload.metadata[0].totalRecord
          },
          // loadingLog: true,
          loadingLogList: false,
          loadingListData: false,
        };
      case LOG_SEARCH_PARAMATERS_UPDATE:
        return {
          ...state,
          sortingParams: { ...payload }
        };
      case LOADING_ON_LOG_SUBMIT:
        return {
          ...state,
          loadingLog: true
        };
      case LOADING_LOG_LIST_DATA:
        return {
          ...state,
          loadingListData: true
        };
      default:
        return state;
    }
  }
